import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../assets/logo_hpfs.png';
import productsData from '../data/products.json';

export default function Header() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openSubs, setOpenSubs] = useState([]);

  async function handleCatalogueDownload(e){
    e.preventDefault();
    const url = `${process.env.PUBLIC_URL}/assets/catalogue/hpfs_catalogue.pdf`;
    try{
      const res = await fetch(url);
      if(!res.ok) throw new Error('Download failed');
      const blob = await res.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'hpfs_catalogue.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    }catch(err){
      console.error(err);
      window.open(url, '_blank');
    }
  }

  function submitSearch(e){
    e.preventDefault();
    const term = (q || '').trim();
    if(!term) return;
    navigate(`/search?q=${encodeURIComponent(term)}`);
    setQ('');
  }

  function toggleSub(id){
    setOpenSubs(prev => prev.includes(id) ? prev.filter(x=>x!==id) : [...prev,id]);
  }

  function closeMobile(){
    setMobileOpen(false);
  }

  return (
    <header className="site-header">
      <div className="top-bar">
        <div className="container" style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <form className="top-search" onSubmit={submitSearch} role="search">
            <input aria-label="Search products" placeholder="Search 1000+ products..." value={q} onChange={(e)=>setQ(e.target.value)} />
            <button className="btn" type="submit"><i className="fas fa-search" aria-hidden="true"></i></button>
          </form>
          <div style={{display:'flex',gap:12}}>
          <div className="highlights"><i className="fas fa-phone" aria-hidden="true"></i> +61 439602113</div>
          <button className='highlights' onClick={handleCatalogueDownload}>
             <i className="fas fa-download" aria-hidden="true"></i> Product Catalogue
          </button>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="brand">
          <img src={logo} alt="logo" className="site-logo" />
        </div>
        <button
          className={"hamburger" + (mobileOpen? ' open':'')}
          aria-label={mobileOpen? 'Close menu' : 'Open menu'}
          aria-expanded={mobileOpen}
          onClick={()=>setMobileOpen(v=>!v)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={"main-nav" + (mobileOpen? ' open':'')} aria-expanded={mobileOpen}>
          <NavLink to="/" end className={({isActive})=> isActive? 'active':''} onClick={closeMobile}>Home</NavLink>
          <NavLink to="/about" className={({isActive})=> isActive? 'active':''} onClick={closeMobile}>About</NavLink>
          <NavLink to="/clients" className={({isActive})=> isActive? 'active':''} onClick={closeMobile}>Clients</NavLink>
          <NavLink to="/certificate" className={({isActive})=> isActive? 'active':''} onClick={closeMobile}>Certificate</NavLink>

          <div className="dropdown" aria-haspopup="true">
            <NavLink to="/products" className={({isActive})=> isActive? 'active':''} onClick={()=>{closeMobile();}}>Products</NavLink>
            <div className="dropdown-menu" role="menu">
              <ul>
                {productsData.categories.map((c) => (
                  <li key={c.id} className={c.subcategories && c.subcategories.length? 'has-sub':''}>
                    <a href={`/products/${c.id}`} onClick={(e)=>{e.preventDefault(); navigate(`/products/${c.id}`); closeMobile();}}>{c.name}</a>
                    {c.subcategories && c.subcategories.length > 0 && (
                      <>
                        {/* <button className="sub-toggle" aria-expanded={openSubs.includes(c.id)} onClick={()=>toggleSub(c.id)}>{openSubs.includes(c.id)? '▾':'▸'}</button> */}
                        <ul className={"sub-menu" + (openSubs.includes(c.id)? ' open':'')}>
                        {c.subcategories.map((s) => (
                          <li key={s.id}>
                            <a href={`/products/${c.id}/${s.id}`} onClick={(e)=>{e.preventDefault(); navigate(`/products/${c.id}/${s.id}`); closeMobile();}}>{s.name}</a>
                          </li>
                        ))}
                      </ul>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          <NavLink to="/events" className={({isActive})=> isActive? 'active':''} onClick={closeMobile}>Events</NavLink>
          <NavLink to="/gallery" className={({isActive})=> isActive? 'active':''} onClick={closeMobile}>Gallery</NavLink>
          <NavLink to="/contact" className={({isActive})=> isActive? 'active':''} onClick={closeMobile}>Contact</NavLink>
        </nav>
      </div>
    </header>
  );
}
